import {getViewTournamentStat} from '../api/getViewTournamentStat';
import {setGetListTournamentStatAction} from '../action';

const setGetViewTournamentStat = (   params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getViewTournamentStat(params);
  
            if (data.status === 'success') {
                dispatch(setGetListTournamentStatAction(data.data))
            }

        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetViewTournamentStat
}